import { ConnectButton } from '@rainbow-me/rainbowkit'
import '@rainbow-me/rainbowkit/styles.css'

export default function RainbowConnectBtn() {
	return (
		<ConnectButton />
	)
}
